import { render, staticRenderFns } from "./StaticBox.vue?vue&type=template&id=071ed7d0&scoped=true&"
import script from "./StaticBox.vue?vue&type=script&lang=js&"
export * from "./StaticBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071ed7d0",
  null
  
)

export default component.exports